const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const SendMessage = () => import(/* webpackChunkName: "send" */ '@/modules/message/view/send.vue');

export const ROUTE_NAME_MESSAGE = {
    SEND: 'SendMessage'
} as const;

export default [
    {
        path: '/app/:appId/message',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'send',
                name: ROUTE_NAME_MESSAGE.SEND,
                component: SendMessage,
                meta: { requiresAuth: true }
            }
        ]
    }
];
